module.exports = __webpack_public_path__ + "static/media/bem_its_logo.49957d6d.png";